import { ChooseOrgOptions, LoginConfig } from '@ardoq/api-types';
import { ApiResponse } from './types';
import { fetchJson, headers } from './api';

const fetchLoginConfig = (): ApiResponse<LoginConfig> => {
  const request = new Request('/auth/login-config', { headers });
  return fetchJson<LoginConfig>(request);
};

const fetchChooseOrgOptions = (): ApiResponse<ChooseOrgOptions> => {
  const request = new Request('/auth/choose-org-options', { headers });
  return fetchJson<ChooseOrgOptions>(request);
};

export const authApi = {
  fetchLoginConfig,
  fetchChooseOrgOptions,
};
